<template>
  <div class="app-container">
    <el-form
      :model="data"
      :inline="true"
      :line-form="true"
      label-width="100px"
      status-icon
    >
      <el-row class="border">
        <el-form-item label="BOM版本号"  prop="Bomno">
          <!-- <el-input
            style="width: 180px;"
            clearable
            v-model="data.Bomno"
            placeholder="请输入BOM版本号" 
          /> -->
          <span>{{ data.Bomno }}</span>
        </el-form-item>
        <el-form-item label="存货名称"  prop="ProductName">
            <!-- <account-select  style="width: 180px;" v-model="data.ProductName" :source="DAccount" @select="onSelect($event)"
            :pageSize="pageParams.pageSize" :pageIndex="pageParams.pageIndex" :listTotal='listTotal'
            @inputText="inputText" @click.native="resetFun" @currentPage="currentPage" :pageType='false' /> -->
            <span>{{ data.ProductName }}</span>
        </el-form-item>
        <el-form-item label="存货条码">
          <span  style="width: 180px;" class="span el-form-item__content">{{
            data.BarCode
          }}</span>
        </el-form-item>
        <el-form-item label="存货编码">
          <span  style="width: 180px;" class="span el-form-item__content">{{
            data.ProductNo
          }}</span>
        </el-form-item>
        <!-- <el-form-item label="颜色" prop="ColorId"  >
          <el-select
            style="width: 180px;"
            v-model="data.ColorId"
            placeholder="请选择颜色"
            clearable
            @change="changeColor"
          >
            <el-option
              v-for="item in ColorList"
              :key="item.ColorId"
              :label="item.ColorName"
              :value="item.ColorId"
            >
            </el-option>
          </el-select>
          <span>{{ data.ColorName }}</span>
        </el-form-item> -->
        <el-form-item label="单位">
          <span  style="width: 180px;" class="span el-form-item__content">{{
            data.PdUnitName
          }}</span>
        </el-form-item> 
        <el-form-item label="数量"  prop="Quantity">
          <!-- <el-input
          style="width: 180px;"
            :min="1"
            clearable
            v-model="data.Quantity"
            type="number" 
            v-int
            placeholder="请输入数值"
            @change="changeQuantity"
          /> -->
          <span>{{ data.Quantity }}</span>
        </el-form-item>
        <el-form-item label="是否默认">
          <el-checkbox v-model="data.IsDefault" disabled></el-checkbox>
        </el-form-item>
      </el-row>
    </el-form>
    <el-tabs tab-position="top" type="card" >
      <!-- <el-button type="text" @click.stop="saveCombinationData">保存</el-button> -->
      <!-- <el-tab-pane v-if="showTab5">
        <div slot="label">组合BOM</div>
        <wj-combination ref="combination" :combination="Combination"/>
      </el-tab-pane> -->
      <!-- <el-button type="text" @click.stop="saveAssembleData">保存</el-button> -->
      <!-- <el-tab-pane v-if="showTab4">
         <div slot="label" >装配BOM</div>
        <wj-assemble ref="assemble" :assembling="Assembling" />
      </el-tab-pane> -->
      <!-- <el-button type="text" @click.stop="saveFittingsData">保存</el-button> -->
      <!-- <el-tab-pane v-if="showTab3">
        <div slot="label">配件BOM</div>
        <wj-fittings ref="fittings" :Parts="Parts" />
      </el-tab-pane> -->
      <!-- <el-button type="text"  @click.stop="saveSpecialData">保存</el-button> -->
      <!-- <el-tab-pane v-if="showTab2">
        <div slot="label">特殊工艺BOM</div>
        <wj-special ref="special" :special="Special" />
      </el-tab-pane> -->
      <!-- <el-button type="text" :flag="flag" @click.stop="saveGlue">保存</el-button> -->
      <el-tab-pane v-if="showTab1">
        <div slot="label">注塑BOM({{Injection.length}})</div>
        <wj-glue ref="glue"  :glue-table="Injection" />
      </el-tab-pane>
      <el-tab-pane
          v-for="(item, index) in machiningStageList"
          :key="index"
          :label="item.Name+'BOM('+item.len+')'"
          :name="item.Name"
        >
          <wj-currency :currency="Currency" :Stage="item.MachiningStageId" :StageName="item.Name"></wj-currency>
        </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import wjCombination from "@/components/production/craftsmanship/bom/wjCombination";
import wjAssemble from "@/components/production/craftsmanship/bom/wjAssemble";
import wjFittings from "@/components/production/craftsmanship/bom/wjFittings";
import wjSpecial from "@/components/production/craftsmanship/bom/wjSpecial";
import wjGlue from "@/components/production/craftsmanship/bom/wjGlue";
import wjCurrency from "@/components/production/craftsmanship/bom/wjCurrency";

import accountSelect from '@/components/production/clothmanagement/cloth/select'


export default {
  name:"editbom",
  components: {
    wjCombination,
    wjAssemble,
    wjFittings,
    wjSpecial,
    wjGlue,
    accountSelect,
    wjCurrency
  },
  data() {
    return {
      colorApi: require("@/api/ba/color").default,
      productApi: require("@/api/ba/product").default,
      api: require("@/api/production/teProduct").default,
      mouldApi: require('@/api/ba/mould').default,
      propertyApi: require('@/api/ba/property').default,
      teProcessApi: require("@/api/production/teProcess").default,
      //加工类型
      machiningStageApi: require("@/api/ba/machiningStage").default,
      mouldList: [],

      Combination: [],
      Assembling: [],
      Parts: [],
      Special: [],
      Injection: [],
      Currency: [],
    
      data: {
        TeProductId: 0,
        ProductId: 0,
        Bomno: "",
        ColorId: null,
        Quantity: null,
        IsDefault: true,
        ProductName: "",
        ProductNo: "",
        PdUnitId: "",
        PdUnitName: "",

      },
      machiningStageList: [],
      
      showTab1: true,
      showTab2: true,
      showTab3: true,
      showTab4: true,
      showTab5: true
    };
  },
  created() {

    this.init()
    this.machiningStageApi.list({ Status: 1,Universal:true }).then((res) => {
      this.machiningStageList = res.Data;
        this.machiningStageList.forEach(x=>{
          var item=this.Currency.find(w=>x.MachiningStageId==w.MachiningStageId)
          x.len=0;
          if(item){

            x.len=item.Data.length;
          }
        });
    });

    /** 显示启用加工阶段 */
    this.machiningStageApi.list({ Status: 0 }).then(res => {
      if(res.Code === 0){
        res.Data.forEach(item => {
          if(item.Name === '注塑'){
            if(!item.Status){
              this.showTab1 = false
              this.showTab2 = false
            } 
          }
          if(item.Name === '配件'){
            if(!item.Status) this.showTab3 = false
          }
          if(item.Name === '装配'){
            if(!item.Status) this.showTab4 = false
          }
          if(item.Name === '组合'){
            if(!item.Status) this.showTab5 = false
          }
        })
      }
    })

  },
  methods: {
    init(){
       var loading = this.$loading({
          lock: true,
          text: "正在查找...",
          spinner: "el-icon-loading",
          customClass: "my_loading",
          background: "rgba(0, 0, 0, 0.3)",
        });
   
        this.getBom_Data(this.$route.params.data)
        loading.close();
    
    },
    
    getBom_Data(data){
      console.log("data",data)
      this.$nextTick(() => {

        this.data.ProductName = data.ProductName;
        this.data.BarCode  = data.BarCode;
        this.data.ProductNo = data.ProductNo;
        this.data.Quantity = data.Quantity;
        this.data.Bomno = data.Bomno;
        this.data.IsDefault = data.IsDefault
        this.data.PdUnitId = data.PdUnitId;
        this.data.PdUnitName = data.PdUnitName;


        console.log('data', data)

        this.Combination = data.Combination;
        this.Assembling = data.Assembling;
        this.Parts = data.Parts;
        this.Special = data.Special;
        this.Injection = data.Injection;
        this.Currency = data.MachiningStage;
        let MouldBomDtos = data.MouldBomDtos;

      

        this.$refs.glue.setTableData(MouldBomDtos)


      })
    },
    getDetailModels(DetailModels){
      let arr = [];
      let name = 
      DetailModels.forEach(item => {
        let { BomType, Bomno, ColorId, ColorName, ImgUrl, Pname, Pno, UseProcess, UseColor,
          ProcessStage, ProduceTypeName, ProductId, ProductName,Remarks,
          ProductNo, ProductSpec, Property, Quantity, TeProductDetailId, TeProductId, TebomId, 
          TespecialBomId, PdUnitId, PdUnitName, MouldId, MouldNo, MouldName} = item
          name = ProductName;
          ProductName = Pname;
          ProductNo = Pno;


          let ids = this.productListAll.map(item => {
            return item.ProductId
          })

          let index = ids.indexOf(ProductId);
           
          let Colors =  this.productListAll[index].Colors

          let colorIds = Colors.map(item => {
            return item.ColorId
          })
          let colorIndex = colorIds.indexOf(ColorId)

          if(colorIndex !== -1){
            ColorName = Colors[colorIndex].ColorName
          }

          let propertyIds = this.propertyList.map(item => {
            return item.PropertyId
          })

          let propertyIndex = propertyIds.indexOf(Property);

          let PropertyName = ""

          if(propertyIndex !== -1){
            let propertyItem =  this.propertyList[propertyIndex]
            PropertyName = propertyItem.PropertyName
          }
          
          let o = {
          BomType, Bomno, ColorId, ImgUrl, Pname, Pno, ColorName, UseProcess, UseColor, PropertyName,
          ProcessStage, ProduceTypeName, ProductId, ProductName,
          ProductNo, ProductSpec, Property, Quantity, TeProductDetailId, TeProductId, TebomId, TespecialBomId,
          MouldId, MouldNo, MouldName,
          PdUnitId, PdUnitName, Colors, Remarks,
          T: null
          };
          arr.push(o)
      })
      let _arr = [];
      let o = {
        name,
        child: arr
      }
      _arr.push(o)



      return _arr
    },
    combinationChange(index, o){
      if(index != null){
        this.$refs.assemble.delProcess(index, o)
      }
      

      this.tabClick({index: '1'});
      this.tabClick({index: '2'});
      this.tabClick({index: '3'});
      this.tabClick({index: '4'});
    },
    assembleChange(index, o){
      
      
      if(index != null){
        this.$refs.fittings.delProcess(index, o)
      }
      
      this.tabClick({index: '2'});
      this.tabClick({index: '3'});
      this.tabClick({index: '4'});

    },
    glueChange(index, o){
      if(index != null){
        this.$refs.glue.delProcess(index, o)
      }
    },
    onSelect(e) {

      console.log('e', e)

      this.data.ColorId = null;
      this.data.ProductName = e.ProductName;
      this.data.ProductNo = e.ProductNo;
      this.ColorList = e.Colors;
      this.data.PdUnitId = e.PdUnitId;
      this.data.PdUnitName = e.PdUnitName;
      this.data.ProductId = e.ProductId;
      this.data.ProductSpec = e.ProductSpec;
      this.data.ProcessStage = e.ProcessStage
      console.log('this.data.ProcessStage', this.data.ProcessStage)

      let ids = this.productList.map(item => {
        return item.ProductId
      })

      let index = ids.indexOf(this.data.ProductId);

      if(this.productList[index].ProcessStage === 4){

        this.isSelectCombination = true;

        this.assembleData = []
        this.subAssembleData = [];

        let currentProduct = [];

        currentProduct.push(this.productList[index]);


        this.combinationData = currentProduct
        this.$set(this.combinationData[0], 'ColorId', this.data.ColorId)
        this.$set(this.combinationData[0], 'ColorName', this.data.ColorName)
        this.$set(this.combinationData[0], 'Quantity', this.data.Quantity)

        
      }else{
        this.isSelectCombination = false;

        this.combinationData = []
        this.subCombinationData = [];

        let assembleData = [];
        assembleData.push(this.productList[index]);

        this.assembleData = assembleData
        this.$set(this.assembleData[0], 'ColorId', this.data.ColorId)
        this.$set(this.assembleData[0], 'ColorName', this.data.ColorName)
        this.$set(this.assembleData[0], 'Quantity', this.data.Quantity)
      }

    },
    resetFun() {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
    },
    currentPage(val) {

      this.pageParams.pageIndex = val
      this.productApi.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) {
          this.DAccount = res.Data;
          this.listTotal = res.Count
        }
      });
    },
    inputText(text) {
      this.productApi.list({  ProductName: text }).then((res) => {
        if (res.Code == 0) {
          this.DAccount = res.Data;

          this.listTotal = res.Count
        }
      });
    },
    // tabClick({ index }) {
    //   switch (index) {
    //     case "4":
     
    //       this.glueData = this.Injection;
    //       console.log('glueData', this.glueData)

    //       // 根据模号分类
    //       let o = {};
    //       this.glueData.forEach(item => {

    //         if(o['_'+item.MouldId] == null){
    //           o['_'+item.MouldId] = [];
    //         }
    //         if(o['_'+item.MouldId]){
    //           let v = {
    //             ProductId: item.ProductId,
    //             ProductName: item.ProductName,
    //             Quantity: Number(item.Quantity),
    //           }
    //           o['_'+item.MouldId].push(v)
    //         }
    //       })



    //       // 根据id 获取产出的胶件及其数量
    //       let mouldId_arr = Object.keys(o);

    //       let Pres = [];
    //       for(let i = 0; i < mouldId_arr.length; ++i){
    //         // console.log('mouldId_arr[i].substr(1)', mouldId_arr[i].substr(1), typeof mouldId_arr[i].substr(1))

    //         if(mouldId_arr[i].substr(1) !== 'null'){
    //           let id = Number(mouldId_arr[i].substr(1))
    //           let p = this.mouldApi.info(id)
    //           Pres.push(p)
    //         }
           
    //       }
    //       if(Pres.length === 0){
            
    //         return
    //       }

    //       Promise.all(Pres).then(res => {

    //         let length = res.length;
    //         let quas = [];
    //         for(let i = 0; i < length; ++i){

    //           if(res[i].Code === 0){
    //             let dataArr = res[i].Data.Rubbers;
    //             let mouldId = res[i].Data.MouldId;

    //             // 根据对应id拿到之前保存的需求数量
    //             let productsQuas = o['_'+mouldId];


    //             let productsQuaLength = productsQuas.length;
    //             let maxQua = 0;
    //             for(let j = 0; j < productsQuaLength; ++j){
    //               let mouldQuas = dataArr.filter(item => {
    //                 console.log('item', item)
    //                 console.log('productsQuas[j]', productsQuas[j])

    //                 return item.ProductId === productsQuas[j].ProductId;
    //               })[0];
    //               console.log('mouldQuas', mouldQuas)



    //               let qua = Math.ceil(productsQuas[j].Quantity / mouldQuas.Quantity);

    //               if(qua > maxQua){
    //                 maxQua = qua;
    //               }
    //             }
    //             quas.push({
    //               MouldId: mouldId,
    //               Quantity: maxQua
    //             })
    //           }

              

    //         }


    //         let mouldIds = this.glueData.map(item => {
    //           return item.MouldId;
    //         })

    //         mouldIds = Array.from(new Set(mouldIds)) // 去除重複的id

    //         let ids = this.mouldList.map(item => {
    //           return item.MouldId
    //         })
    //         console.log('ids', ids)

    //         let arr3 = [];

    //         console.log('mouldIds', mouldIds)
    //         mouldIds.forEach(item => {
    //           let index = ids.indexOf(item);
    //           console.log('index', index)
    //             let qua = quas.filter(v => {
    //               return item === v.MouldId
    //             })[0]
    //           console.log('qua====', qua)
    //           console.log('mouldList[index]====', this.mouldList[index])

    //             if(qua){
    //               let o = {
    //                 Quantity: qua.Quantity,
    //                 ...this.mouldList[index]
    //               }
    //               arr3.push(o)
    //             }
                
    //         })

    //         console.log('----arr3-----', arr3)

    //         // let arr3 = [];
    //         // let mould_ids = [];

    //         // this.mould_data.forEach(item => {
    //         //   mould_ids.push(item.MouldId)
    //         //   arr3.push(item)
    //         // })
    //         // mouldIds.forEach(item => {
    //         //   if(mould_ids.indexOf(item) === -1){
    //         //     let index = ids.indexOf(item);
    //         //     let qua = quas.filter(v => {
    //         //       return item === v.MouldId
    //         //     })[0]
    //         //     let o = {
    //         //       Bomno: "",
    //         //       Quantity: qua.Quantity,
    //         //       TebomId: 0,
    //         //       Remarks: "",
    //         //       ...this.mouldList[index]
    //         //     }
    //         //     arr3.push(o)
    //         //   }
    //         // })
    //         this.$refs.glue.setTableData(arr3)
            
    //       })

          


           
          
    //         break;
    //     }
    // },
    save(row) {},
    viewImg(imgURL) {},
    changeColor(val){
      let ids = this.ColorList.map(item => {
        return item.ColorId
      })
      let index = ids.indexOf(val);
      let color = this.ColorList[index];

      this.data.ColorName =  color.ColorName;
      this.data.ColorId =  color.ColorId;

      if(this.assembleData.length === 0){
        this.$set(this.combinationData[0], 'ColorId', color.ColorId)
        this.$set(this.combinationData[0], 'ColorName', color.ColorName)
      }else{
        this.$set(this.assembleData[0], 'ColorId', color.ColorId)
        this.$set(this.assembleData[0], 'ColorName', color.ColorName)
      }
    
    },
    changeQuantity(val){
       if(this.assembleData.length === 0){
          this.$set(this.combinationData[0], 'Quantity', val)

      }else{
        this.$set(this.assembleData[0], 'Quantity', val)
      }
    
    },
    getBOMData(type, _data){

      let o = {};
      if(type === 4){
        let {BomType, Bomno, ColorId, ColorName, DetailModels, 
          ProcessStage, ProduceTypeName, ProductId, ProductName, 
          ProductNo, ProductSpec, Quantity, TebomId, ProcessModels, ProgrammeId, Remarks} = _data[0];

        let Bom = {
          Pname: ProductName,
          Pno: ProductNo,
          PdUnitId: this.data.PdUnitId,
          PdUnitName: this.data.PdUnitName,
          BomType, Bomno, ColorId, ColorName, 
          Remarks,
          ProcessStage, ProduceTypeName, ProductId, 
          ProductSpec, Quantity, TebomId,
          ProgrammeId,
        }

        o = {
          Bom,
          DetailModels,
          ProcessModels
        }
      }
      return o
    },
    getCombinationData(){
      
      let BomModels = []
      if(this.isSelectCombination){
       BomModels = this.$refs.combination.copyData()
      }

      if(BomModels.length !== 0){

        // let length = BomModels.length;
        // for(let i = 0; i < length; ++i){
        //   let {TebomId, Bomno, DetailModels} = BomModels[i];
        //   console.log('循环ing')
        //   if(DetailModels.length !== 0 && this.wjCombinationKey['_'+TebomId] === Bomno){
        //     this.$message({type: 'warning', message: `原bom版本${this.wjCombinationKey['_'+TebomId]}的子列表有变动，请先修改其版本号`})
        //     return
        //   }
        // }

         this.data.Quantity = Number(this.data.Quantity)
          let o = {
            BomModels,
            ...this.data
          }

          return o
          
      }else{
        return false;
      }

      
    },
    getAssembleData(){
       let BomModels = this.$refs.assemble.copyData()

      if(BomModels.length !== 0){
        // let length = BomModels.length;
        // for(let i = 0; i < length; ++i){
        //   let {TebomId, Bomno, DetailModels} = BomModels[i];
        //   console.log('循环ing')
        //   if(DetailModels.length !== 0 && this.wjAssembleKey['_'+TebomId] === Bomno){
        //     this.$message({type: 'warning', message: `原bom版本${this.wjAssembleKey['_'+TebomId]}的子列表有变动，请先修改其版本号`})
        //     return
        //   }
        // }

        this.data.Quantity = Number(this.data.Quantity)
        let o = {
          BomModels,
          ...this.data
        }

        return o

      }else{
        return false
      }
    },
    getFittingsData(){
       let BomModels = this.$refs.fittings.copyData()


      if(BomModels.length !== 0){
        // let length = BomModels.length;
        // for(let i = 0; i < length; ++i){
        //   let {TebomId, Bomno, DetailModels} = BomModels[i];
        //   console.log('循环ing')
        //   if(DetailModels.length !== 0 && this.wjFittingsKey['_'+TebomId] === Bomno){
        //     this.$message({type: 'warning', message: `原bom版本${this.wjFittingsKey['_'+TebomId]}的子列表有变动，请先修改其版本号`})
        //     return
        //   }
        // }

        this.data.Quantity = Number(this.data.Quantity)
        let o = {
          BomModels,
          ...this.data
        }

        return o
        
      }else{
        return false
      }
    },
    getSpecialData(){
      let SpecialBomModels = this.$refs.special.copyData()

      console.log('======SpecialBomModels==========', SpecialBomModels)

      if(SpecialBomModels.length !== 0){
        
        this.data.Quantity = Number(this.data.Quantity);

        let o = {
          SpecialBomModels,
          ...this.data
        }

        return o

      }else{
        return false
      }


    },
    getGlue(){
      let BomModels = this.$refs.glue.copyData()

       if(BomModels.length !== 0){
        //  let length = BomModels.length;
        //   for(let i = 0; i < length; ++i){
        //     let {TebomId, Bomno, DetailModels} = BomModels[i];
        //     if(DetailModels.length !== 0 && this.wjGlueKey['_'+TebomId] === Bomno){
        //       this.$message({type: 'warning', message: `原bom版本${this.wjGlueKey['_'+TebomId]}的子列表有变动，请先修改其版本号`})
        //       return
        //     }
        //   }

          this.data.Quantity = Number(this.data.Quantity)
          let o = {
            BomModels,
            ...this.data
          }

          return o
          
       }else{
        return false;
       }
     
    },
    copySave(){

      let {Bomno, ProductId,  ColorId, Quantity} = this.data;
      if(Bomno === ""){
        this.$message({type: 'warning', message: '请在表头输入版本号'})
        return
      }

      if(ProductId === 0){
        this.$message({type: 'warning', message: '请在表头选择存货'})
        return
      }

      if(ColorId == null){
        this.$message({type: 'warning', message: '请在表头选择颜色'})
        return
      }

      if(Quantity == null){
        this.$message({type: 'warning', message: '请在表头输入数量'})
        return
      }


      let o1 = this.getCombinationData();

      if(o1){
        o1.TeProductId = 0;
        o1.BomModels.forEach(item => {
          item.TebomId = 0;
          item.DetailModels.forEach(v1 => {
            v1.TebomId = 0;
            v1.T = 0
            v1.TeProductDetailId = 0;
          })

          item.ProcessModels.forEach(v1 => {
            v1.TebomId = 0;
            v1.T = 0
            v1.TeProductProcessId = 0;
          })
        })
        console.log('o1', o1)

      }

     


      if(o1){
        var loading = this.$loading({
          lock: true,
          text: "正在复制...",
          spinner: "el-icon-loading",
          customClass: "my_loading",
          background: "rgba(0, 0, 0, 0.3)",
        });
        this.api.bomSave(o1).then(res => {
          if(res.Code === 0){
              this.$message({
                type: 'success',
                message: res.Msg
              })
              if(res.Data !== 0){
                this.TeProductId = res.Data;
              }

              let params = [];


              let o2 = this.getAssembleData();

              console.log('o2====', o2)

      
              if(o2){
                o2.TeProductId = this.TeProductId;
                o2.BomModels.forEach(item => {
                  item.TebomId = 0;
                  item.DetailModels.forEach(v1 => {
                    v1.TebomId = 0;
                    v1.T = 0
                    v1.TeProductDetailId = 0;
                  })

                  item.ProcessModels.forEach(v1 => {
                    v1.TebomId = 0;
                    v1.T = 0
                    v1.TeProductProcessId = 0;
                  })
                })
                console.log('o2', o2)
                params.push(o2)
              }


              let o3 = this.getFittingsData();
              console.log('o3====', o3)


              if(o3){
                o3.TeProductId = this.TeProductId;
                o3.BomModels.forEach(item => {
                  item.TebomId = 0;
                  item.DetailModels.forEach(v1 => {
                    v1.TebomId = 0;
                    v1.T = 0
                    v1.TeProductDetailId = 0;
                  })

                  item.ProcessModels.forEach(v1 => {
                    v1.TebomId = 0;
                    v1.T = 0
                    v1.TeProductProcessId = 0;
                  })
                })
                console.log('o3', o3)
                params.push(o3)
              }


              let o4 = this.getSpecialData();
              console.log('o4====', o4)
              
              if(o4){
                o4.TeProductId = this.TeProductId;
                o4.SpecialBomModels.forEach(item => {
                  item.TebomId = 0;
                  item.TespecialBomId = 0;
                  item.TeProductId = this.TeProductId;
                  item.DetailModels.forEach(v1 => {
                    v1.TebomId = 0;
                    v1.T = 0
                    v1.TeProductDetailId = 0;
                    v1.TespecialBomId = 0;
                  })
                  
                })
                console.log('o4', o4)
                params.push(o4)

              }


              let o5 = this.getGlue();
              console.log('o5====', o5)

              if(o5){
                o5.TeProductId = this.TeProductId;
                o5.BomModels.forEach(item => {
                  item.TebomId = 0;
                  item.DetailModels.forEach(v1 => {
                    v1.TebomId = 0;
                    v1.TeProductDetailId = 0;
                    v1.T = 0
                  })

                  item.ProcessModels.forEach(v1 => {
                    v1.TebomId = 0;
                    v1.TeProductProcessId = 0;
                    v1.T = 0
                  })
                })
                console.log('o5', o5)
                params.push(o5)
              }
              
              let ps = [];
              for(let i = 0; i < params.length; ++i){
                let p = this.api.bomSave(params[i]);
                ps.push(p)
              }

              Promise.all(ps).then(res => {
                loading.close()

                var loading1 = this.$loading({
                  lock: true,
                  text: "正在更新数据...",
                  spinner: "el-icon-loading",
                  customClass: "my_loading",
                  background: "rgba(0, 0, 0, 0.3)",
                });
                
                this.api.getInfo(this.TeProductId).then(res => {
                  loading1.close()
                  if(res.Code === 0){
                    this.getBom_Data(res.Data)
                  }
                }).catch(err => {
                  loading1.close()
                })
              }).catch(err => {
                loading.close()
              })


            }else{
              this.$message({
                type: 'warning',
                message: res.Msg
              })
              loading.close()
            }
        }).catch(err => {
           loading.close()
        })

        
      }

      if(o1 === false){

        let o2 = this.getAssembleData();


        if(o2){
          o2.TeProductId = 0;
          o2.BomModels.forEach(item => {
            item.TebomId = 0;
            item.DetailModels.forEach(v1 => {
              v1.TebomId = 0;
              v1.T = 0
              v1.TeProductDetailId = 0;
            })

            item.ProcessModels.forEach(v1 => {
              v1.TebomId = 0;
              v1.T = 0
              v1.TeProductProcessId = 0;
            })
          })
          console.log('o2', o2)
        }

        if(o2){
          var loading = this.$loading({
          lock: true,
          text: "正在复制...",
          spinner: "el-icon-loading",
          customClass: "my_loading",
          background: "rgba(0, 0, 0, 0.3)",
        });
        this.api.bomSave(o2).then(res => {
          if(res.Code === 0){
              this.$message({
                type: 'success',
                message: res.Msg
              })
              if(res.Data !== 0){
                this.TeProductId = res.Data;
              }

              let params = [];


              let o3 = this.getFittingsData();

              if(o3){
                o3.TeProductId = this.TeProductId;
                o3.BomModels.forEach(item => {
                  item.TebomId = 0;
                  item.DetailModels.forEach(v1 => {
                    v1.TebomId = 0;
                    v1.T = 0
                    v1.TeProductDetailId = 0;
                  })

                  item.ProcessModels.forEach(v1 => {
                    v1.TebomId = 0;
                    v1.T = 0
                    v1.TeProductProcessId = 0;
                  })
                })
                console.log('o3', o3)
                params.push(o3)
              }


              let o4 = this.getSpecialData();
              if(o4){
                o4.TeProductId = this.TeProductId;
                o4.SpecialBomModels.forEach(item => {
                  item.TebomId = 0;
                  item.TespecialBomId = 0;
                  item.TeProductId = this.TeProductId;
                  item.DetailModels.forEach(v1 => {
                    v1.TebomId = 0;
                    v1.T = 0
                    v1.TeProductDetailId = 0;
                    v1.TespecialBomId = 0;
                  })
                  
                })
                console.log('o4', o4)
                params.push(o4)

              }


              let o5 = this.getGlue();
              if(o5){
                o5.TeProductId = this.TeProductId;
                o5.BomModels.forEach(item => {
                  item.TebomId = 0;
                  item.DetailModels.forEach(v1 => {
                    v1.TebomId = 0;
                    v1.TeProductDetailId = 0;
                    v1.T = 0
                  })

                  item.ProcessModels.forEach(v1 => {
                    v1.TebomId = 0;
                    v1.TeProductProcessId = 0;
                    v1.T = 0
                  })
                })
                console.log('o5', o5)
                params.push(o5)
              }
              
              let ps = [];
              for(let i = 0; i < params.length; ++i){
                let p = this.api.bomSave(params[i]);
                ps.push(p)
              }

              Promise.all(ps).then(res => {
                loading.close()

                var loading1 = this.$loading({
                  lock: true,
                  text: "正在更新数据...",
                  spinner: "el-icon-loading",
                  customClass: "my_loading",
                  background: "rgba(0, 0, 0, 0.3)",
                });
                
                this.api.getInfo(this.TeProductId).then(res => {
                  loading1.close()
                  if(res.Code === 0){
                    this.getBom_Data(res.Data)
                  }
                }).catch(err => {
                  loading1.close()
                })
              }).catch(err => {
                loading.close()
              })


            }else{
              this.$message({
                type: 'warning',
                message: res.Msg
              })
              loading.close()
            }
        }).catch(err => {
           loading.close()
        })
        }

        

        
      }

      // if(params.length !== 0){

      //   let ps = [];
        // var loading = this.$loading({
        //   lock: true,
        //   text: "正在复制...",
        //   spinner: "el-icon-loading",
        //   customClass: "my_loading",
        //   background: "rgba(0, 0, 0, 0.3)",
        // });
        // for(let i = 0; i < params.length; ++i){
        //   let p = this.api.bomSave(params[i]);
        //   ps.push(p)
        // }

        // Promise.all(ps).then(res => {
        //   loading.close()
        //   console.log('res=========', res)
        // }).catch(err => {
        //   loading.close()
        // })
        
      // }

      

      

      

    },
    bomSave(){
      let {Bomno, ProductId,  ColorId, Quantity} = this.data;
      if(Bomno === ""){
        this.$message({type: 'warning', message: '请在表头输入版本号'})
        return
      }

      if(ProductId === 0){
        this.$message({type: 'warning', message: '请在表头选择存货'})
        return
      }

      if(ColorId == null){
        this.$message({type: 'warning', message: '请在表头选择颜色'})
        return
      }

      if(Quantity == null){
        this.$message({type: 'warning', message: '请在表头输入数量'})
        return
      }

      let o = {
        Combination: null,
        Assembling: null,
        Parts: null,
        Special: null,
        Injection: null,
        ...this.data
      }
      let _Combination = this.$refs.combination.getSaveData(1);;

      if(_Combination.length !== 0){
        let Combination = this.getBOMData(4, _Combination)
        o.Combination = Combination;
      }

      console.log('组合信息', _Combination)


      let boms1 = this.$refs.assemble.getSaveData(1);
      if(boms1.length !== 0){
        let Assembling = {
          Boms: []
        };
        Assembling.Boms.push(...boms1)

        o.Assembling = Assembling

      }
      
      console.log('获取装配', boms1)

      let boms2 = this.$refs.fittings.getSaveData(1);
      if(boms2.length !== 0){
        let Parts = {
          Boms: []
        }
        Parts.Boms.push(...boms2)
        o.Parts = Parts
      }

      console.log('获取配件', boms2)



      let boms3 = this.$refs.special.getSaveData(1);
      if(boms3.length !== 0){
        let Special = {
          Boms: []
        };
        Special.Boms.push(...boms3)
        o.Special = Special;

      }

      console.log('获取特殊', boms3)


      let MouldBoms = this.$refs.glue.getSaveData(1);
      if(MouldBoms.length !== 0){
        let Injection = {
          MouldBoms: []
        }
        Injection.MouldBoms.push(...MouldBoms)

        o.Injection = Injection

      }
      console.log('获取模具', MouldBoms)

      console.log('全阶保存', o)

      if((o.Combination || this.data.ProcessStage === 3) && (o.Assembling || boms1) && (o.Parts || boms2) && (o.Special || boms3) && (o.Injection || MouldBoms)){

        var loading = this.$loading({
          lock: true,
          text: "正在保存...",
          spinner: "el-icon-loading",
          customClass: "my_loading",
          background: "rgba(0, 0, 0, 0.3)",
        });
         this.api.save(o).then(res => {
          if(res.Code === 0){
            this.$message({
              type: 'success',
              message: res.Msg
            })
            loading.close();
            if(res.Data !== 0){
              this.TeProductId = res.Data;
            }
            this.api.getInfo(this.TeProductId).then(res => {
              if(res.Code === 0){
                  this.getBom_Data(res.Data)
                }
            })
          }else{
            this.$message({
              type: 'warning',
              message: res.Msg
            })
            loading.close();

          }
        }).catch(err => {
          loading.close();
        })
      }else{

        this.$message({type: 'warning', message: '请把所有阶段的内容填写完整'})
        return
       
      }


     

    }
  },
};
</script>

<style lang="scss" scoped>
.el-tabs {
  padding: 18px;
}
.w193px {
  width: 193px;
}
.span {
  display: inline-block;
}
</style>
